module.exports = __webpack_public_path__ + "img/f3-2-r.f1dd09a2.png";